<template>
  <div class="cookie" data-view>

    <Header bgColor="#7D3A73" mobBg="linear-gradient(180deg, #7D3A73 8.27%, #B489AD 101.47%)"></Header>

    <div class="section1 section">
      <div id="parallax">
        <img data-depth="0.3" class="parallax-item parallax-item1" src="../assets/conf/section-parralax1.png" alt="">
        <img data-depth="0.4" class="parallax-item parallax-item2" src="../assets/conf/section-parralax2.png" alt="">
        <img data-depth="0.5" class="parallax-item parallax-item3" src="../assets/conf/section-parralax3.png" alt="">
      </div>
      <div class="content">
        <h1>Політика щодо «cookie-файлів»</h1>
      </div>
    </div>

    <div class="section2 section">
      <div id="parallax2">
        <img data-depth="0.3" class="parallax-item parallax-item1" src="../assets/conf/section-parralax2.png" alt="">
        <img data-depth="0.4" class="parallax-item parallax-item2" src="../assets/conf/section-parralax1.png" alt="">
        <img data-depth="0.5" class="parallax-item parallax-item3" src="../assets/conf/section-parralax3.png" alt="">
      </div>
      <div class="content">
        <div class="step1 step">
          <div class="title">1. Вступ</div>
          <div class="text"><span class="bold">Cookie-файли</span> – це невеликі текстові файли, які автоматично
            зберігаються на Вашому комп'ютері інтернет-браузером, коли Ви відвідуєте веб-сайт. Cookie-файли
            використовуються для різних цілей, наприклад, щоб гарантувати, що веб-сайт функціонує правильно. Веб-сайт
            <a href="https://vaccinehub.sanofi.ua/" target="_blank">https://vaccinehub.sanofi.ua/</a> («Сайт») також
            використовує Cookie-файли, деякі з яких можуть потребувати Вашої попередньої згоди. Звертаємо Вашу увагу, що
            якщо Ви не згодні з використанням цих конкретних Cookie-файлів, деякі функціональні можливості,
            запропоновані Сайтом, можуть не працювати, як передбачалося.
          </div>
        </div>
        <div class="step2 step">
          <div class="title">2. Які Cookie-файли використовуються?</div>
          <div class="text">
            <span class="italic">Функціональні Cookie-файли</span><br>
            Ці Cookie-файли технічно необхідні для функціонування Сайту, які можуть включати так звані «Cookie-файли для
            даної сесії» або «постійні Cookie-файли».
          </div>
          <div class="text">
            <span class="italic">Google Analytics</span><br>
            Через Сайт компанією Google розміщується файл Cookie як частина послуги «Аналітика». Компанія «Санофі»
            використовує цей сервіс для відстеження взаємодій користувача з Сайтом. Інформація, отримана за допомогою
            цих Cookie-файлів, може передаватися і зберігатися компанією Google на серверах у Сполучених Штатах Америки.
            У налаштуваннях нашого акаунта Google Analytics ми визначили, що Google не може отримати доступ до повної
            IP-адреси Вашого комп'ютера (це означає, що останній октет цієї ІР-адреси не стане відомим Google). Крім
            того, ми визначили, що Google не може використовувати інформацію, яка збирається їхніми Cookie-файлами на
            нашому Сайті, для своїх власних цілей. Ви можете відмовитися від Cookie-файлів Google Analytics, встановивши
            плагін Google (https://tools.google.com/dlpage/gaoptout) (зовнішнє посилання)).

          </div>
          <div class="text">
            <span class="italic">Соціальні мережі (потрібен дозвіл)</span><br>
            Цей Сайт містить кнопки для того, щоб просувати або ділитися сторінками в соціальних мережах, наприклад
            Facebook або Twitter. Ці кнопки працюють через код, який стає доступним безпосередньо через компанії
            соціальних мереж. Цей код, крім усього іншого, розміщує Cookie-файли, для чого ми потребуємо Вашого
            схвалення.

          </div>
          <div class="text">
            Будь ласка, ознайомтеся з політикою конфіденційності кожної з цих компаній (яка періодично може змінюватися)
            для розуміння того, що вони роблять з (персональними) даними, які вони збирають за допомогою цього коду.
          </div>
        </div>
      </div>
    </div>

    <div class="med-text">
      <footer
          id="self-medication-block">
        <div class="word">
          <div class="letter s"></div>
          <div
              class="letter a"></div>
          <div
              class="letter m bigger-letter"></div>
          <div
              class="letter o"></div>
          <div
              class="letter l"></div>
          <div
              class="letter i smaller-letter"></div>
          <div
              class="letter k"></div>
          <div
              class="letter u"></div>
          <div class="letter v"></div>
          <div class="letter a"></div>
          <div
              class="letter n"></div>
          <div class="letter n"></div>
          <div class="letter ia"></div>
        </div>
        <div
            class="word">
          <div
              class="letter m bigger-letter"></div>
          <div class="letter o"></div>
          <div
              class="letter ge bigger-letter"></div>
          <div class="letter e"></div>
        </div>
        <div class="word">
          <div
              class="letter b"></div>
          <div class="letter u"></div>
          <div class="letter t"></div>
          <div
              class="letter ii"></div>
        </div>
        <div class="word">
          <div
              class="letter sh bigger-letter"></div>
          <div
              class="letter k"></div>
          <div
              class="letter i smaller-letter"></div>
          <div
              class="letter d"></div>
          <div
              class="letter l"></div>
          <div class="letter ii"></div>
          <div class="letter v"></div>
          <div
              class="letter ii"></div>
          <div
              class="letter m bigger-letter"></div>
        </div>
        <div class="word">
          <div
              class="letter d"></div>
          <div class="letter l"></div>
          <div class="letter ia"></div>
        </div>
        <div
            class="word">
          <div class="letter v"></div>
          <div class="letter a"></div>
          <div
              class="letter sh bigger-letter"></div>
          <div class="letter o"></div>
          <div
              class="letter g"></div>
          <div
              class="letter o"></div>
        </div>
        <div class="word">
          <div class="letter z"></div>
          <div
              class="letter d"></div>
          <div class="letter o"></div>
          <div class="letter r"></div>
          <div
              class="letter o"></div>
          <div class="letter v"></div>
          <div
              class="letter znak smaller-letter"></div>
          <div class="letter ia"></div>
        </div>

        <svg id="self-medication-svg" viewBox="0 0 316 88" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M5.96402 10.3896C3.40201 10.3896 1.89001 11.5236 1.89001 14.0436V36.5976C1.89001 39.1596 3.40201 40.2516 5.96402 40.2516H6.84601C9.40802 40.2516 10.962 39.1596 10.962 36.5976V33.0696H10.122V35.5476C10.122 38.6556 9.36601 39.4956 6.84601 39.4956H5.96402C3.44402 39.4956 2.73001 38.6556 2.73001 35.5476V15.0936C2.73001 11.9856 3.44402 11.1456 5.96402 11.1456H6.84601C9.36601 11.1456 10.122 11.9856 10.122 15.0936V17.6136H10.962V14.0436C10.962 11.4816 9.40802 10.3896 6.84601 10.3896H5.96402ZM24.1976 39.9996L20.1236 10.5996H18.8216L14.7476 39.9996H15.5036L16.9736 29.3316H21.9716L23.4416 39.9996H24.1976ZM19.4096 11.5236H19.4936L20.1656 16.4796L21.8456 28.5336H17.0996L18.7796 16.4796L19.4096 11.5236ZM41.727 39.9996V10.5996H40.257L35.385 39.5376H35.301L30.429 10.5996H28.959V39.9996H29.799V11.8176H29.883L34.629 39.9996H36.057L40.845 11.8176H40.929V39.9996H41.727ZM51.5274 10.3896C48.9654 10.3896 47.4534 11.5236 47.4534 14.0436V36.5976C47.4534 39.1596 48.9654 40.2516 51.5274 40.2516H52.4094C54.9714 40.2516 56.5254 39.1596 56.5254 36.5976V14.0436C56.5254 11.4816 54.9714 10.3896 52.4094 10.3896H51.5274ZM52.4094 11.1456C54.9294 11.1456 55.6854 11.9856 55.6854 15.0936V35.5476C55.6854 38.6556 54.9294 39.4956 52.4094 39.4956H51.5274C49.0074 39.4956 48.2934 38.6556 48.2934 35.5476V15.0936C48.2934 11.9856 49.0074 11.1456 51.5274 11.1456H52.4094ZM71.8823 39.9996V10.5996H64.4903L63.4403 35.5476C63.3143 38.5716 62.9363 39.4956 61.2983 39.4956H61.1723V40.2516H61.2563C62.9363 40.2516 64.0703 39.2856 64.1963 36.7656L65.2463 11.4396H71.0423V40.0416L71.8823 39.9996ZM78.6466 39.9996V10.5996H77.8066V39.9996H78.6466ZM88.9406 24.4596L93.3926 10.5996H92.5946L88.2686 24.0816H85.4126V10.5996H84.5726V39.9996H85.4126V24.8376H88.2686L92.8466 39.9996H93.6446L88.9406 24.4596ZM101.204 39.9996L106.58 10.5996H105.782L102.002 31.1376L98.2643 10.5996H97.4663L101.582 33.1536L100.322 39.9996H101.204ZM111.435 10.6416V39.9996H116.349C118.953 39.9996 120.507 38.9076 120.507 36.3036V27.1476C120.507 25.3836 119.793 24.3336 118.533 23.7876C119.667 23.2416 120.297 22.1916 120.297 20.5536V14.3376C120.297 11.7336 118.743 10.6416 116.139 10.6416H111.435ZM112.275 11.3976H116.181C118.701 11.3976 119.457 12.2376 119.457 15.3456V19.5036C119.457 22.5276 118.785 23.4096 116.433 23.4516H112.275V11.3976ZM112.275 24.2076H116.391C118.911 24.2496 119.667 25.0476 119.667 28.1556V35.2957C119.667 38.4037 118.911 39.2436 116.391 39.2436H112.275V24.2076ZM133.737 39.9996L129.663 10.5996H128.361L124.287 39.9996H125.043L126.513 29.3316H131.511L132.981 39.9996H133.737ZM128.949 11.5236H129.033L129.705 16.4796L131.385 28.5336H126.639L128.319 16.4796L128.949 11.5236ZM147.697 39.9996V10.5996H146.857V23.6196H139.465V10.5996H138.625V39.9996H139.465V24.4596H146.857V39.9996H147.697ZM162.707 39.9996V10.5996H161.867V23.6196H154.475V10.5996H153.635V39.9996H154.475V24.4596H161.867V39.9996H162.707ZM177.035 39.9996V10.6416H172.121C169.517 10.6416 168.005 11.7336 168.005 14.3376V21.1416C168.005 22.8216 168.635 23.8716 169.811 24.4176C168.677 24.9636 168.005 26.0136 168.005 27.6936V40.0416H168.845V28.7436C168.845 25.8036 169.475 24.9216 171.659 24.7956H176.195V40.0416L177.035 39.9996ZM176.195 11.3976V24.0396H171.659C169.475 23.9556 168.845 23.0316 168.845 20.0916V15.3456C168.845 12.2376 169.559 11.3976 172.121 11.3976H176.195ZM203.58 39.9996V10.5996H202.11L197.238 39.5376H197.154L192.282 10.5996H190.812V39.9996H191.652V11.8176H191.736L196.482 39.9996H197.91L202.698 11.8176H202.782V39.9996H203.58ZM213.38 10.3896C210.818 10.3896 209.306 11.5236 209.306 14.0436V36.5976C209.306 39.1596 210.818 40.2516 213.38 40.2516H214.262C216.824 40.2516 218.378 39.1596 218.378 36.5976V14.0436C218.378 11.4816 216.824 10.3896 214.262 10.3896H213.38ZM214.262 11.1456C216.782 11.1456 217.538 11.9856 217.538 15.0936V35.5476C217.538 38.6556 216.782 39.4956 214.262 39.4956H213.38C210.86 39.4956 210.146 38.6556 210.146 35.5476V15.0936C210.146 11.9856 210.86 11.1456 213.38 11.1456H214.262ZM234.365 24.4596L238.397 10.5996H237.599L233.693 24.0816H231.257V10.5996H230.417V24.0816H227.981L224.075 10.5996H223.277L227.267 24.4596L223.025 39.9996H223.823L227.981 24.8376H230.417V39.9996H231.257V24.8376H233.651L237.809 39.9996H238.607L234.365 24.4596ZM252.126 11.4396V10.5996H243.474V39.9996H252.126V39.2016H244.314V24.4596H251.496V23.6196H244.314V11.4396H252.126ZM273.639 11.4396V10.5996H264.987V39.9996H269.901C272.505 39.9996 274.059 38.9076 274.059 36.3036V27.1476C274.059 24.5856 272.505 23.4516 269.901 23.4516H265.827V11.4396H273.639ZM265.827 24.2496H269.943C272.463 24.2496 273.219 25.0476 273.219 28.1556V35.2957C273.219 38.4037 272.463 39.2436 269.943 39.2436H265.827V24.2496ZM281.578 39.9996L286.954 10.5996H286.156L282.376 31.1376L278.638 10.5996H277.84L281.956 33.1536L280.696 39.9996H281.578ZM299.41 11.4396V10.5996H290.758V11.4396H294.664V39.9996H295.504V11.4396H299.41ZM313.138 39.9996V10.5996H311.668L304.99 39.2436L304.948 10.5996H304.108V39.9996H305.578L312.256 11.3556H312.34V39.9996H313.138Z"
              fill="#3F4C56"/>
          <path
              d="M15.0529 77.4377V48.1681H14.2167V76.6432H8.98996V48.1681H8.15369V76.6432H2.92698V48.1681H2.0907V77.4377H15.0529ZM22.3759 61.9666L26.8081 48.1681H26.0137L21.7069 61.5903H18.8635V48.1681H18.0273V77.4377H18.8635V62.343H21.7069L26.2646 77.4377H27.059L22.3759 61.9666ZM29.8184 77.4377V48.1681H28.9821V77.4377H29.8184ZM42.5337 76.6432V48.1681H35.1326L34.0873 72.7546C33.9619 75.5143 33.6692 76.476 32.3729 76.6432H31.7457V76.8523V82.8317H32.582V77.4377H42.6173V82.8317H43.4536V76.6432H42.5337ZM35.8853 49.0044H41.6974V76.6432H33.9619C34.4636 76.0997 34.7981 75.2634 34.84 74.009L35.8853 49.0044ZM54.9964 77.4377V48.1681H47.6372L46.5919 73.0054C46.4664 76.016 46.0901 76.9359 44.4594 76.9359H44.3339V77.6886H44.4176C46.0901 77.6886 47.2191 76.7269 47.3445 74.218L48.3899 49.0044H54.1602V77.4795L54.9964 77.4377ZM66.832 77.4377V48.1681H65.3685L58.7201 76.6851L58.6783 48.1681H57.8421V77.4377H59.3055L65.9539 48.9208H66.0375V77.4377H66.832ZM69.6574 48.2099V77.4377H74.5496C77.142 77.4377 78.6891 76.3505 78.6891 73.7581V64.6427C78.6891 62.8865 77.9783 61.8412 76.7239 61.2976C77.8528 60.754 78.48 59.7087 78.48 58.078V51.8895C78.48 49.2971 76.9329 48.2099 74.3405 48.2099H69.6574ZM70.4936 48.9626H74.3823C76.8911 48.9626 77.6438 49.7989 77.6438 52.8931V57.0326C77.6438 60.0432 76.9748 60.9213 74.6332 60.9631H70.4936V48.9626ZM70.4936 61.7158H74.5914C77.1002 61.7576 77.8528 62.552 77.8528 65.6462V72.7546C77.8528 75.8488 77.1002 76.6851 74.5914 76.6851H70.4936V61.7158ZM89.4359 77.4377V48.1681H87.9724L81.324 76.6851L81.2822 48.1681H80.4459V77.4377H81.9094L88.5578 48.9208H88.6414V77.4377H89.4359ZM104.847 77.4377V48.1681H103.384L98.5333 76.9777H98.4497L93.5993 48.1681H92.1358V77.4377H92.9721V49.3807H93.0557L97.7807 77.4377H99.2023L103.969 49.3807H104.053V77.4377H104.847ZM123.845 76.6432V48.1681H116.444L115.399 72.7546C115.273 75.5143 114.98 76.476 113.684 76.6432H113.057V76.8523V82.8317H113.893V77.4377H123.929V82.8317H124.765V76.6432H123.845ZM117.197 49.0044H123.009V76.6432H115.273C115.775 76.0997 116.109 75.2634 116.151 74.009L117.197 49.0044ZM136.308 77.4377V48.1681H128.949L127.903 73.0054C127.778 76.016 127.401 76.9359 125.771 76.9359H125.645V77.6886H125.729C127.401 77.6886 128.53 76.7269 128.656 74.218L129.701 49.0044H135.471V77.4795L136.308 77.4377ZM147.223 77.4377V48.2099H142.331C139.739 48.2099 138.233 49.2971 138.233 51.8895V58.6634C138.233 60.3359 138.861 61.3812 140.031 61.9248C138.902 62.4684 138.233 63.5137 138.233 65.1863V77.4795H139.07V66.2316C139.07 63.3047 139.697 62.4266 141.871 62.3011H146.387V77.4795L147.223 77.4377ZM146.387 48.9626V61.5485H141.871C139.697 61.4649 139.07 60.545 139.07 57.618V52.8931C139.07 49.7989 139.781 48.9626 142.331 48.9626H146.387ZM156.465 48.2099V77.4377H161.357C163.95 77.4377 165.497 76.3505 165.497 73.7581V64.6427C165.497 62.8865 164.786 61.8412 163.531 61.2976C164.66 60.754 165.288 59.7087 165.288 58.078V51.8895C165.288 49.2971 163.74 48.2099 161.148 48.2099H156.465ZM157.301 48.9626H161.19C163.699 48.9626 164.451 49.7989 164.451 52.8931V57.0326C164.451 60.0432 163.782 60.9213 161.441 60.9631H157.301V48.9626ZM157.301 61.7158H161.399C163.908 61.7576 164.66 62.552 164.66 65.6462V72.7546C164.66 75.8488 163.908 76.6851 161.399 76.6851H157.301V61.7158ZM175.742 77.4377L171.686 48.1681H170.389L166.334 77.4377H167.086L168.55 66.817H173.526L174.989 77.4377H175.742ZM170.975 49.088H171.058L171.728 54.022L173.4 66.0226H168.675L170.348 54.022L170.975 49.088ZM190.643 77.4377V48.1681H189.806V76.6432H184.58V48.1681H183.743V76.6432H178.517V48.1681H177.68V77.4377H190.643ZM197.464 47.959C194.913 47.959 193.408 49.088 193.408 51.5968V74.0508C193.408 76.6014 194.913 77.6886 197.464 77.6886H198.342C200.893 77.6886 202.44 76.6014 202.44 74.0508V51.5968C202.44 49.0462 200.893 47.959 198.342 47.959H197.464ZM198.342 48.7117C200.851 48.7117 201.603 49.548 201.603 52.6422V73.0054C201.603 76.0997 200.851 76.9359 198.342 76.9359H197.464C194.955 76.9359 194.244 76.0997 194.244 73.0054V52.6422C194.244 49.548 194.955 48.7117 197.464 48.7117H198.342ZM213.798 49.0044V48.1681H205.184V77.4377H206.021V49.0044H213.798ZM219.169 47.959C216.619 47.959 215.113 49.088 215.113 51.5968V74.0508C215.113 76.6014 216.619 77.6886 219.169 77.6886H220.047C222.598 77.6886 224.145 76.6014 224.145 74.0508V51.5968C224.145 49.0462 222.598 47.959 220.047 47.959H219.169ZM220.047 48.7117C222.556 48.7117 223.309 49.548 223.309 52.6422V73.0054C223.309 76.0997 222.556 76.9359 220.047 76.9359H219.169C216.661 76.9359 215.95 76.0997 215.95 73.0054V52.6422C215.95 49.548 216.661 48.7117 219.169 48.7117H220.047ZM236.214 47.959C233.622 47.959 232.117 49.0462 232.117 51.5968V54.2729H232.953V52.6422C232.953 49.548 233.664 48.7117 236.214 48.7117H237.051C239.559 48.7117 240.27 49.548 240.27 52.6422V57.0326C240.27 60.0432 239.601 60.9213 237.302 60.9631H234.249V61.7158H237.26C239.769 61.7576 240.479 62.552 240.479 65.6462V73.0054C240.479 76.0997 239.769 76.9359 237.26 76.9359H236.214C233.664 76.9359 232.953 76.0997 232.953 73.0054V71.3747H232.117V74.0508C232.117 76.6014 233.622 77.7304 236.214 77.6886H237.26C239.81 77.7304 241.316 76.6014 241.316 74.0508V64.6427C241.316 62.8865 240.605 61.8412 239.392 61.2976C240.479 60.754 241.107 59.7087 241.107 58.078V51.6387C241.107 49.088 239.601 47.959 237.051 47.959H236.214ZM253.002 76.6432V48.1681H245.601L244.556 72.7546C244.43 75.5143 244.137 76.476 242.841 76.6432H242.214V76.8523V82.8317H243.05V77.4377H253.086V82.8317H253.922V76.6432H253.002ZM246.354 49.0044H252.166V76.6432H244.43C244.932 76.0997 245.266 75.2634 245.308 74.009L246.354 49.0044ZM259.694 47.959C257.144 47.959 255.638 49.088 255.638 51.5968V74.0508C255.638 76.6014 257.144 77.6886 259.694 77.6886H260.572C263.123 77.6886 264.67 76.6014 264.67 74.0508V51.5968C264.67 49.0462 263.123 47.959 260.572 47.959H259.694ZM260.572 48.7117C263.081 48.7117 263.834 49.548 263.834 52.6422V73.0054C263.834 76.0997 263.081 76.9359 260.572 76.9359H259.694C257.186 76.9359 256.475 76.0997 256.475 73.0054V52.6422C256.475 49.548 257.186 48.7117 259.694 48.7117H260.572ZM267.415 48.2099V77.4377H268.251V62.7193H272.307C274.9 62.7193 276.447 61.5903 276.447 59.0397V51.8895C276.447 49.2971 274.9 48.2099 272.307 48.2099H267.415ZM268.251 48.9626H272.349C274.858 48.9626 275.61 49.7989 275.61 52.8931V58.0361C275.61 61.1304 274.858 61.9666 272.349 61.9666H268.251V48.9626ZM282.625 47.959C280.074 47.959 278.569 49.088 278.569 51.5968V74.0508C278.569 76.6014 280.074 77.6886 282.625 77.6886H283.503C286.054 77.6886 287.601 76.6014 287.601 74.0508V51.5968C287.601 49.0462 286.054 47.959 283.503 47.959H282.625ZM283.503 48.7117C286.012 48.7117 286.765 49.548 286.765 52.6422V73.0054C286.765 76.0997 286.012 76.9359 283.503 76.9359H282.625C280.116 76.9359 279.405 76.0997 279.405 73.0054V52.6422C279.405 49.548 280.116 48.7117 282.625 48.7117H283.503ZM290.345 48.2099V77.4377H295.238C297.83 77.4377 299.377 76.3505 299.377 73.7581V64.6427C299.377 62.8865 298.666 61.8412 297.412 61.2976C298.541 60.754 299.168 59.7087 299.168 58.078V51.8895C299.168 49.2971 297.621 48.2099 295.029 48.2099H290.345ZM291.182 48.9626H295.07C297.579 48.9626 298.332 49.7989 298.332 52.8931V57.0326C298.332 60.0432 297.663 60.9213 295.321 60.9631H291.182V48.9626ZM291.182 61.7158H295.279C297.788 61.7576 298.541 62.552 298.541 65.6462V72.7546C298.541 75.8488 297.788 76.6851 295.279 76.6851H291.182V61.7158ZM301.887 51.7223L302.848 48.1681H301.845L301.259 51.7223H301.887ZM313.707 77.4377V48.2099H308.815C306.223 48.2099 304.717 49.2971 304.717 51.8895V58.6634C304.717 60.3359 305.344 61.3812 306.515 61.9248C305.386 62.4684 304.717 63.5137 304.717 65.1863V77.4795H305.554V66.2316C305.554 63.3047 306.181 62.4266 308.355 62.3011H312.871V77.4795L313.707 77.4377ZM312.871 48.9626V61.5485H308.355C306.181 61.4649 305.554 60.545 305.554 57.618V52.8931C305.554 49.7989 306.264 48.9626 308.815 48.9626H312.871Z"
              fill="#3F4C56"/>
        </svg>


      </footer>
    </div>

    <bottomBlock></bottomBlock>
  </div>
</template>

<script>
import Parallax from "parallax-js";
import Header from '../components/main-header.vue';

export default {
  name: "cookie",
  components: {
    Header,
  },
  mounted() {

    window.document.title = 'Політика щодо "cookie-файлів" | VaccineHUB';
    let allMetaElements = document.getElementsByTagName('meta');
    for (let i = 0; i < allMetaElements.length; i++) {
      if (allMetaElements[i].getAttribute("name") === "description") {
        allMetaElements[i].setAttribute('content', "Політика щодо \"cookie-файлів\" на VaccineHub");
        break;
      }
    }

    var scene = document.getElementById('parallax');
    var parallaxInstance = new Parallax(scene);


    var scene2 = document.getElementById('parallax2');
    var parallaxInstance2 = new Parallax(scene2);
  }
}
</script>

<style scoped lang="scss">
$fontR: "Raleway-Regular";
$fontM: "Raleway-Medium";
$fontSB: "Raleway-SemiBold";
$fontB: "Raleway-Bold";
$fontSBI: "Raleway-SemiBoldItalic";
.cookie {

  .section {
    position: relative;
    overflow: hidden;

    &.section1 {
      width: 100%;
      background: #D9E7EF;
      display: flex;
      justify-content: center;
      border-radius: 0 0 20px 20px;

      .parallax-item1 {
        left: -12% !important;
        top: -41% !important;
        width: 50%;
      }

      .parallax-item2 {
        left: 0 !important;
        right: 0 !important;
        top: -45% !important;
        margin: 0 auto;
        width: 50%;
      }

      .parallax-item3 {
        left: auto !important;
        right: -15% !important;
        top: -35% !important;
        margin: 0 auto;
        width: 50%;
      }

      .content {
        padding: 80px 10px;
        position: relative;
        z-index: 2;

        h1 {
          text-align: center;
          color: #602F58;
          font-family: $fontB;
          font-size: 72px;
          font-weight: normal;

          @media screen and (max-width: 1024px) {
            font-size: 58px;
          }
          @media screen and (max-width: 900px) {
            font-size: 48px;
          }
          @media screen and (max-width: 768px) {
            font-size: 36px;
            text-align: left;
          }
        }
      }
    }

    &.section2 {
      display: flex;
      justify-content: center;

      #parallax2 {
        .parallax-item1 {
          left: -15% !important;
          top: -5% !important;

          width: 35%;
        }

        .parallax-item2 {
          left: auto !important;
          right: -10% !important;
          top: 30% !important;

          width: 35%;
        }

        .parallax-item3 {
          left: -10% !important;
          top: auto !important;
          bottom: -120% !important;

          width: 35%;
        }
      }

      .content {
        position: relative;
        z-index: 2;
        padding: 60px 10px;
        max-width: 850px;

        .step {
          margin-bottom: 60px;

          @media screen and (max-width: 768px) {
            margin-bottom: 24px;
          }

          .title {
            color: #602F58;
            font-family: $fontM;
            font-size: 32px;
            margin-bottom: 24px;
            @media screen and (max-width: 1024px) {
              font-size: 26px;
            }
            @media screen and (max-width: 900px) {
              font-size: 24px;
            }

          }

          .text {
            margin-bottom: 24px;
            font-size: 21px;
            color: #3F4C56;
            font-family: $fontR;
            @media screen and (max-width: 1024px) {
              font-size: 18px;
            }

            a {
              text-decoration: none;
              color: #2E7BBD;
            }

            .bold {
              font-family: $fontSB;
            }

            .italic {
              font-family: $fontSBI;
              display: inline-block;
              margin-bottom: 5px;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    #parallax, #parallax2 {
      position: absolute !important;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;

      .parallax-item {
        position: absolute;
        height: auto;
        display: block;
      }
    }

    .content {
      max-width: 1300px;
      width: 100%;
      padding: 40px 10px;
    }
  }

  .med-text {

    // Regular Monitor > 1024px
    @media (min-width: 1025px) {
      #self-medication-block {
        display: flex !important;
        justify-content: space-around !important;
        align-items: center !important;

        #self-medication-svg {
          display: none !important;
        }

        .word {
          display: flex !important;
        }
      }
    }

    // Tablets < 1024px
    @media (max-width: 1025px) {
      #self-medication-block {
        #self-medication-svg {
          display: block !important;
        }

        .word {
          display: none !important;
        }
      }
    }

    #self-medication-block {
      width: 100%;
      height: 15vh;
      bottom: 0;
      left: 0;
      position: fixed;
      z-index: 100;

      box-shadow: 0 0 20px 0 rgba(154, 90, 176, 0.2);
      background: #EFF1F3;


      #self-medication-svg {
        width: 100%;
        height: 100%;

        .self-medication-svg-letter {
          fill: #A5A4A4;
        }
      }

      .word {
        display: flex;
        justify-content: center;

        .letter {
          width: 2vw;
          height: 15vh;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;

          &.bigger-letter {
            width: 3vw;
          }

          &.smaller-letter {
            width: 1vw;
          }

          &.znak {
            background-image: url('../assets/img/footer/znak.svg');
          }

          &.s {
            background-image: url('../assets/img/footer/s_letter.svg');
          }

          &.a {
            background-image: url('../assets/img/footer/a_letter.svg');
          }

          &.m {
            background-image: url('../assets/img/footer/m_letter.svg');
          }

          &.o {
            background-image: url('../assets/img/footer/o_letter.svg');
          }

          &.l {
            background-image: url('../assets/img/footer/l_letter.svg');
          }

          &.i {
            background-image: url('../assets/img/footer/i_letter.svg');
          }

          &.k {
            background-image: url('../assets/img/footer/k_letter.svg');
          }

          &.u {
            background-image: url('../assets/img/footer/u_letter.svg');
          }

          &.v {
            background-image: url('../assets/img/footer/v_letter.svg');
          }

          &.n {
            background-image: url('../assets/img/footer/n_letter.svg');
          }

          &.e {
            background-image: url('../assets/img/footer/e_letter.svg');
          }

          &.b {
            background-image: url('../assets/img/footer/b_letter.svg');
          }

          &.t {
            background-image: url('../assets/img/footer/t_letter.svg');
          }

          &.g {
            background-image: url('../assets/img/footer/g_letter.svg');
          }

          &.d {
            background-image: url('../assets/img/footer/d_letter.svg');
          }

          &.z {
            background-image: url('../assets/img/footer/z_letter.svg');
          }

          &.r {
            background-image: url('../assets/img/footer/r_letter.svg');
          }

          &.ia {
            background-image: url('../assets/img/footer/ia_letter.svg');
          }

          &.ge {
            background-image: url('../assets/img/footer/ge_letter.svg');
          }

          &.ii {
            background-image: url('../assets/img/footer/ii_letter.svg');
          }

          &.sh {
            background-image: url('../assets/img/footer/sh_letter.svg');
          }
        }
      }
    }
  }

}

</style>